@let product = loadedProduct();
@if (!product) {
  <div>
    <h3>Loading Product</h3>
  </div>
}
<form #productForm="ngForm">
  @if (product && !pricesVisible) {
    <div>
      <div class="toolbar">
        <span>
          <button matButton="text" [disabled]="isBusy()" (click)="backToProductSearch()">
            <span>
              <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
              <label>Back To Search</label>
            </span>
          </button>
        </span>
        <span class="spacer"></span>
        <span>
          @if (!isNew()) {
            <button matButton="text" [disabled]="isBusy()" (click)="viewSkuSlots()">
              <span>
                <mat-icon class="size-16">edit</mat-icon>
                <label>Sku Slots</label>
              </span>
            </button>
          }
          @if (!isNew()) {
            <button matButton="text" [disabled]="isBusy()" (click)="showPrices()">
              <span>
                <mat-icon class="size-16">attach_money</mat-icon>
                <label>Pricing</label>
              </span>
            </button>
          }
          <button matButton="text" [disabled]="!productForm.valid || isBusy()" (click)="saveProduct()">
            <span>
              <mat-icon class="size-16">done</mat-icon>
              <label>Save</label>
            </span>
          </button>
        </span>
      </div>
      <div class="centered">
        <h5 class="smallerMargin">Required fields are marked with an asterisk (*)</h5>
      </div>
      <table class="inputLayout">
        <tr>
          <td class="leftColumnLabel"><label for="productIdInput">*Product ID:</label></td>
          <td class="leftColumnInput"><input name="productIdInput" class="inputField standardTextBox" maxlength="50" id="productIdInput" required [(ngModel)]="product.productId" #productId="ngModel"/></td>
          <td class="middleColumnLabel"><label for="productTypeInput">*Product Type:</label></td>
          <td class="middleColumnInput">
            <select name="productTypeInput" id="productTypeInput" class="inputField" required [(ngModel)]="product.typeCode" #productTypeInput="ngModel">
              <option value="undefined" disabled>Please Select</option>
              @for (productType of productTypes(); track productType) {
                <option [value]="productType.code">{{ productType.description }}</option>
              }
            </select>
          </td>
          <td class="rightColumnLabel"><label for="isActiveInput">Active:</label></td>
          <td class="rightColumnInput"><input name="isActiveInput" type="checkbox" class="checkboxInput" id="isActiveInput" [(ngModel)]="product.active"/></td>
        </tr>
        <tr>
          <td class="leftColumnLabel"><label for="descriptionInput">*Description:</label></td>
          <td class="leftColumnInput">
            <textarea name="descriptionInput" id="descriptionInput" cols="25" maxlength="200" class="inputField standardTextBox noresize" rows="2" required [(ngModel)]="product.description" #productDescription="ngModel">
            </textarea>
          </td>
          <td class="middleColumnLabel"><label for="commodityCodeInput">Commodity:</label></td>
          <td class="middleColumnInput">
            <select name="commodityCodeInput" id="commodityCodeInput" class="inputField" [(ngModel)]="product.commodityCode">
              <option value="undefined" disabled>Please Select</option>
              @for (commodity of commodities(); track commodity) {
                <option [value]="commodity.code">{{ commodity.description }}</option>
              }
            </select>
          </td>
          <td class="rightColumnLabel"><label for="isOrderableInput">Orderable:</label></td>
          <td class="rightColumnInput"><input name="isOrderableInput" type="checkbox" class="checkboxInput" id="isOrderableInput" [(ngModel)]="product.orderable"/></td>
        </tr>
        <tr>
          <td class="leftColumnLabel"><label for="shortDescriptionInput">*Short Description:</label></td>
          <td class="leftColumnInput">
            <input name="shortDescriptionInput" class="inputField standardTextBox" maxlength="30" id="shortDescriptionInput" required [(ngModel)]="product.descriptionShort" #shortDescription="ngModel"/>
          </td>
          <td class="middleColumnLabel"><label for="productLineInput">Product Line:</label></td>
          <td class="middleColumnInput">
            <select name="productLineInput" id="productLineInput" class="inputField" [(ngModel)]="product.productLineCode">
              <option value="undefined" disabled>Please Select</option>
              @for (productLine of productLines(); track productLine) {
                <option [value]="productLine.code">{{ productLine.description }}</option>
              }
            </select>
          </td>
          <td class="rightColumnLabel"><label for="isShippableInput">Shippable:</label></td>
          <td class="rightColumnInput"><input name="isShippableInput" type="checkbox" class="checkboxInput" id="isShippableInput" [(ngModel)]="product.shippableItem"/></td>
        </tr>
        <tr>
          <td class="leftColumnLabel"><label for="ltufOneInput">Product Type:</label></td>
          <td class="leftColumnInput"><input name="ltufOneInput" class="inputField standardTextBox" maxlength="30" id="ltufOneInput" [(ngModel)]="product.largeTextUserField1"/></td>
          <td class="middleColumnLabel"><label for="classCodeInput">Class Code:</label></td>
          <td class="middleColumnInput">
            <select name="classCodeInput" id="classCodeInput" class="inputField" [(ngModel)]="product.classCode">
              <option value="undefined" disabled>Please Select</option>
              @for (productClassCode of productClassCodes(); track productClassCode) {
                <option [value]="productClassCode.code">{{ productClassCode.description }}</option>
              }
            </select>
          </td>
          <td class="rightColumnLabel"><label for="isKitInput">Is Kit:</label></td>
          <td class="rightColumnInput"><input name="isKitInput" type="checkbox" class="checkboxInput" id="isKitInput" [(ngModel)]="product.kit"/></td>
        </tr>
        <tr>
          <td class="leftColumnLabel"><label for="leadTimeInput">*Lead Time:</label></td>
          <td class="leftColumnInput">
            <select name="leadTimeInput" id="leadTimeInput" class="inputField" required [(ngModel)]="product.numericUserField2" #leadTime="ngModel">
              <option value="undefined" disabled>Please Select</option>
              @for (leadTime of productLeadTimes(); track leadTime) {
                <option [value]="leadTime.id">{{ leadTime.description }}</option>
              }
            </select>
          </td>
          <td class="middleColumnLabel"><label for="productModelInput">Product Model:</label></td>
          <td class="middleColumnInput">
            <select name="productModelInput" id="productModelInput" class="inputField" [(ngModel)]="product.productModelCode">
              <option value="undefined" disabled>Please Select</option>
              @for (productModel of productModels(); track productModel) {
                <option [value]="productModel.code">{{ productModel.description }}</option>
              }
            </select>
          </td>
          <td class="rightColumnLabel"><label for="isConfigurationInput">Is Configuration:</label></td>
          <td class="rightColumnInput"><input name="isConfigurationInput" type="checkbox" class="checkboxInput" id="isConfigurationInput" [(ngModel)]="product.configuration"/></td>
        </tr>
        <tr>
          <td class="leftColumnLabel"><label for="ltufTwoInput">Class Code Description:</label></td>
          <td class="leftColumnInput"><input name="ltufTwoInput" class="inputField standardTextBox" maxlength="30" id="ltufTwoInput" [(ngModel)]="product.largeTextUserField2"/></td>
          <td class="middleColumnLabel"><label for="uomCodeInput">*Unit Of Measure:</label></td>
          <td class="middleColumnInput">
            <select name="uomCodeInput" id="uomCodeInput" class="inputField" required [(ngModel)]="product.productUomCode" #uom="ngModel">
              <option value="undefined" disabled>Please Select</option>
              @for (uom of uomCodes(); track uom) {
                <option [value]="uom.code">{{ uom.description }}</option>
              }
            </select>
          </td>
          <td class="rightColumnLabel"><label for="isSparesInput">Spares:</label></td>
          <td class="rightColumnInput"><input name="isSparesInput" type="checkbox" class="checkboxInput" id="isSparesInput" [(ngModel)]="product.spares"/></td>
        </tr>
        <tr>
          <td class="leftColumnLabel"><label for="ltufThreeInput">Where Used (Family):</label></td>
          <td class="leftColumnInput"><input name="ltufThreeInput" class="inputField standardTextBox" maxlength="30" id="ltufThreeInput" [(ngModel)]="product.largeTextUserField3"/></td>
          <td class="middleColumnLabel"><label for="beginEffectiveInput">Begin Effective:</label></td>
          <td class="middleColumnInput">
            <input [matDatepicker]="beginDatePicker" name="beginDateInput" [value]="formatDisplayDate(product.beginEffectiveDate)" (dateChange)="setBeginEffective($event.value)"/>
            <mat-datepicker-toggle [for]="beginDatePicker"></mat-datepicker-toggle>
            <mat-datepicker id="beginDatePicker" name="beginDatePicker" #beginDatePicker></mat-datepicker>
          </td>
          <td class="rightColumnLabel"><label for="isVendorSuppliedInput">Vendor Supplied:</label></td>
          <td class="rightColumnInput"><input name="isVendorSuppliedInput" type="checkbox" class="checkboxInput" id="isVendorSuppliedInput" [(ngModel)]="product.vendorSupplied"/></td>
        </tr>
        <tr>
          <td class="leftColumnLabel"><label for="nufOneInput">Where Used (Size):</label></td>
          <td class="leftColumnInput"><input name="nufOneInput" class="inputField standardTextBox" id="nufOneInput" (ngModelChange)="updateNumericUserField1($event)" [ngModel]="product.numericUserField1 | number:'2.0'"/></td>
          <td class="middleColumnLabel"><label for="endEffectiveInput">End Effective:</label></td>
          <td class="middleColumnInput">
            <input [matDatepicker]="endDatePicker" name="endDateInput" [value]="formatDisplayDate(product.endEffectiveDate)" (dateChange)="setEndEffective($event.value)"/>
            <mat-datepicker-toggle [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker id="endDatePicker" name="endDatePicker" #endDatePicker></mat-datepicker>
          </td>
          <td class="rightColumnLabel"><label for="isModularInput">Modular</label></td>
          <td class="rightColumnInput"><input name="isModularInput" type="checkbox" class="checkboxInput" id="isModularInput" [(ngModel)]="product.modular"/></td>
        </tr>
        <tr>
          <td colspan="3" class="centered-cell"><label>Created: {{ product.createUser }} - {{ product.createTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
          <td colspan="3"><label>Updated: {{ product.updateUser }} - {{ product.updateTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
        </tr>
        @if (productId.invalid && (productId.dirty || productId.touched)) {
          <tr class="errors">
            <td colspan="6" class="alert alert-danger">
              @if (productId.errors?.['required']) {
                <label>Please enter a Product ID</label>
              }
            </td>
          </tr>
        }
        @if (productTypeInput.invalid && (productTypeInput.dirty || productTypeInput.touched)) {
          <tr class="errors">
            <td colspan="6" class="alert alert-danger">
              @if (productTypeInput.errors) {
                <label>Please select a Product Type</label>
              }
            </td>
          </tr>
        }
        @if (productDescription.invalid && (productDescription.dirty || productDescription.touched)) {
          <tr class="errors">
            <td colspan="6" class="alert alert-danger">
              @if (productDescription.errors?.['required']) {
                <label>Please enter a Product Description</label>
              }
            </td>
          </tr>
        }
        @if (shortDescription.invalid && (shortDescription.dirty || shortDescription.touched)) {
          <tr class="errors">
            <td colspan="6" class="alert alert-danger">
              @if (shortDescription.errors?.['required']) {
                <label>Please enter a Short Description</label>
              }
            </td>
          </tr>
        }
        @if (leadTime.invalid && (leadTime.dirty || leadTime.touched)) {
          <tr class="errors">
            <td colspan="6" class="alert alert-danger">
              @if (leadTime.errors) {
                <label>Please select a Lead Time</label>
              }
            </td>
          </tr>
        }
        @if (uom.invalid && (uom.dirty || uom.touched)) {
          <tr class="errors">
            <td colspan="6" class="alert alert-danger">
              @if (uom.errors) {
                <label>Please select a Unit of Measure</label>
              }
            </td>
          </tr>
        }
      </table>
      @if (isBusy()) {
        <span class="busyIndicator">
          <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
          <label class="busyLabel">Please Wait...</label>
        </span>
      }
    </div>
  }
</form>
@if (pricesVisible) {
  <app-product-prices (closeWindow)="pricesVisible=false" [user]="personLogin.person.userLogin" [product]="product"></app-product-prices>
}

